module.exports = "/_next/static/images/avatar_Verca-6888fccb806fd3e83ae459ddb5f5efc2.svg";